import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, useTheme, alpha } from '@mui/material';
const OutlinedIconButton = ({ icon, onClick, size = 'small', disabled = false }) => {
    const theme = useTheme();
    return (_jsx(IconButton, { size: size, onClick: onClick, disabled: disabled, sx: {
            color: theme.palette.text.primary,
            border: `1px solid ${alpha(theme.palette.grey[500], 0.48)}`
        }, children: icon }));
};
export default OutlinedIconButton;
